import { Button, IconButton } from '@mui/material'
import styles from './HostServiceCard.module.css'
import { Link } from 'react-router-dom'
import { ImageSlider } from 'shared/ui/strspykit/ImageSlider'
import CloseIcon from '@mui/icons-material/Close'
import { UnderObservationDoubleIcon } from 'shared/icons/UnderObservationDoubleIcon'

interface HostServiceCardProps {
    hostService: any
    spyId?: number
    index: number
    onStartPropertySpy: (event: any) => void
    onStopPropertySpy: (event: any) => void
    onClose: (event: any) => void
}

export const HostServiceCard = (props: HostServiceCardProps) => {
    const {
        hostService,
        spyId,
        index,
        onStartPropertySpy,
        onStopPropertySpy,
        onClose
    } = props

    const position = hostService.position ? hostService.position : index + 1
    if (hostService === undefined) {
        return (
            <></>
        )
    }

    const handleStateSpy = (event: any) => {
        if (hostService.propSpy === true) {
            onStopPropertySpy?.(hostService)
            return
        }

        onStartPropertySpy?.(hostService)
    }

    const slides = hostService.strHostservicePictures?.map((strHostservicePicture: any) => {
        return ({
            url: strHostservicePicture.url,
            title: strHostservicePicture.description
        })
    })

    const stateSpyText = hostService.propSpy === true ? `Stop spy` : `Spy it`
    const handleCloseButton = (event: any) => {
        onClose?.(hostService)
    }

    const renderUnderObservation = (): JSX.Element => {
        if (hostService.propSpy === true) {
            return (
                <div className={styles.HostServiceCard__UnderObservation}>
                    <UnderObservationDoubleIcon
                        className={styles.HostServiceCard__UnderObservationIcon}
                    />
                    <div className={styles.HostServiceCard__UnderObservationBg}>

                    </div>
                </div>
            )
        }

        return (<></>)
    }

    return (
        <div className={styles.HostServiceCard__Root}>
            <div className={styles.HostServiceCard__ImageSliderContainer}>
                <ImageSlider
                    slides={slides}
                />
                {renderUnderObservation()}
                <div className={styles.HostServiceCard__PositionContainer}>
                    <div className={styles.HostServiceCard__Position}>
                        <div className={styles.HostServiceCard__PositionLabel}>
                            Position:
                        </div>
                        <div className={styles.HostServiceCard__PositionValue}>
                            {position}
                        </div>
                    </div>
                </div>
                <div className={styles.HostServiceCard__CloseButtonContainer}>
                    <IconButton
                        className={styles.HostServiceCard__CloseButton}
                        aria-label=""
                        size="small"
                        onClick={handleCloseButton}
                    >
                        <CloseIcon fontSize="medium" />
                       
                    </IconButton>
                </div>
            </div>
            <div className={styles.HostServiceCard__NameContainer}>
                <div className={styles.HostServiceCard__Name}>
                    {hostService.name}
                </div>
           
            </div>
            <div className={styles.HostServiceCard__MainToolbar}>
                <Link to={`/hostservice/${hostService.id}?monitoridforprices=${spyId}`}>
                    <Button
                        className={styles.HostServiceCard__Button}
                        color="success"
                        variant="contained"
                        sx={{
                            fontSize: '20px',
                            textTransform: 'none'
                        }}
                    >
                        Details
                    </Button >
                </Link>
                <Button
                    className={styles.HostServiceCard__Button}
                    color="success"
                    variant="outlined"
                    sx={{
                        textTransform: 'none',
                        borderWidth: '2px!important',
                        background: `#FFFF`
                    }}
                    onClick={handleStateSpy}          
                >
                    {stateSpyText}
                </Button >
            </div>

        </div>
    )
}